import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/index.vue'),
      meta: { public: true }
    },

    {
      path: '/',
      name: 'Layout',
      component: () => import('@/layouts/MainLayout.vue'),
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/dashboard/index.vue'),
          meta: { titleKey: 'route.dashboard', icon: 'Odometer', menuOrder: { SUPER_ADMIN: 10, AGENT: 10, STORE_ADMIN: 10 } }
        },
        {
          path: 'warranty-summary',
          name: 'WarrantySummary',
          component: () => import('@/views/warranty-summary/index.vue'),
          meta: { titleKey: 'route.warrantySummary', icon: 'DocumentChecked', roles: ['AGENT'], menuOrder: { AGENT: 30 } }
        },
        {
          path: 'my-products',
          name: 'MyProducts',
          component: () => import('@/views/my-products/index.vue'),
          meta: { titleKey: 'route.myProducts', icon: 'Goods', roles: ['AGENT'], menuOrder: { AGENT: 20 } }
        },
        {
          path: 'vehicles',
          name: 'Vehicles',
          component: () => import('@/views/vehicles/index.vue'),
          meta: { titleKey: 'route.vehicles', icon: 'Van', roles: ['SUPER_ADMIN', 'STORE_ADMIN'], menuOrder: { SUPER_ADMIN: 30, STORE_ADMIN: 30 } }
        },
        {
          path: 'members',
          name: 'Members',
          component: () => import('@/views/members/index.vue'),
          meta: { titleKey: 'route.members', icon: 'User', roles: ['SUPER_ADMIN', 'STORE_ADMIN'], menuOrder: { SUPER_ADMIN: 40, STORE_ADMIN: 40 } }
        },
        {
          path: 'stores',
          name: 'Stores',
          component: () => import('@/views/stores/index.vue'),
          meta: { titleKey: 'route.stores', icon: 'Shop', roles: ['SUPER_ADMIN', 'AGENT'], menuOrder: { SUPER_ADMIN: 50, AGENT: 60 } }
        },
        {
          path: 'warranty-register',
          name: 'WarrantyRegister',
          component: () => import('@/views/warranty-register/index.vue'),
          meta: { titleKey: 'route.warrantyRegister', icon: 'EditPen', roles: ['STORE_ADMIN'], menuOrder: { STORE_ADMIN: 12 } }
        },
        {
          path: 'warranty-drafts',
          name: 'WarrantyDrafts',
          component: () => import('@/views/warranty-drafts/index.vue'),
          meta: { titleKey: 'route.warrantyDrafts', icon: 'Tickets', roles: ['STORE_ADMIN'], menuOrder: { STORE_ADMIN: 13 } }
        },
        {
          path: 'warranties',
          name: 'Warranties',
          component: () => import('@/views/warranties/index.vue'),
          meta: { titleKey: 'route.warranties', icon: 'DocumentChecked', roles: ['SUPER_ADMIN', 'STORE_ADMIN', 'AGENT'], menuOrder: { SUPER_ADMIN: 35, STORE_ADMIN: 14, AGENT: 25 } }
        },
        {
          path: 'store-employees',
          name: 'StoreEmployees',
          component: () => import('@/views/store-employees/index.vue'),
          meta: { titleKey: 'route.storeEmployees', icon: 'UserFilled', roles: ['SUPER_ADMIN', 'STORE_ADMIN'], menuOrder: { SUPER_ADMIN: 65, STORE_ADMIN: 15 } }
        },
        {
          path: 'agents',
          name: 'Agents',
          component: () => import('@/views/agents/index.vue'),
          meta: { titleKey: 'route.agents', icon: 'OfficeBuilding', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 55 } }
        },
        {
          path: 'products',
          name: 'Products',
          component: () => import('@/views/products/index.vue'),
          meta: { titleKey: 'route.products', icon: 'Goods', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 70 } }
        },
        {
          path: 'cms-pages',
          name: 'CmsPages',
          component: () => import('@/views/cms/index.vue'),
          meta: { titleKey: 'route.cmsPages', icon: 'Document', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 110 } }
        },
        {
          path: 'website-categories',
          name: 'WebsiteCategories',
          component: () => import('@/views/website/categories/index.vue'),
          meta: { titleKey: 'route.websiteCategories', icon: 'Collection', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 111 } }
        },
        {
          path: 'website-products',
          name: 'WebsiteProducts',
          component: () => import('@/views/website/products/index.vue'),
          meta: { titleKey: 'route.websiteProducts', icon: 'Goods', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 112 } }
        },
        {
          path: 'website-installations',
          name: 'WebsiteInstallations',
          component: () => import('@/views/website/installations/index.vue'),
          meta: { titleKey: 'route.websiteInstallations', icon: 'Picture', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 113 } }
        },
        {
          path: 'website-colors',
          name: 'WebsiteColors',
          component: () => import('@/views/website/colors/index.vue'),
          meta: { titleKey: 'route.websiteColors', icon: 'Brush', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 114 } }
        },
        {
          path: 'website-articles',
          name: 'WebsiteArticles',
          component: () => import('@/views/website/articles/index.vue'),
          meta: { titleKey: 'route.websiteArticles', icon: 'Reading', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 115 } }
        },
        {
          path: 'website-about',
          name: 'WebsiteAbout',
          component: () => import('@/views/website/about/index.vue'),
          meta: { titleKey: 'route.websiteAbout', icon: 'InfoFilled', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 116 } }
        },
        {
          path: 'trace-categories',
          name: 'TraceCategories',
          component: () => import('@/views/trace/categories/index.vue'),
          meta: { titleKey: 'route.traceCategories', icon: 'Collection', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 80 } }
        },
        {
          path: 'trace-installation-areas',
          name: 'TraceInstallationAreas',
          component: () => import('@/views/trace/installation-areas/index.vue'),
          meta: { titleKey: 'route.traceInstallationAreas', icon: 'MapLocation', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 85 } }
        },
        {
          path: 'trace-packages',
          name: 'TracePackages',
          component: () => import('@/views/trace/packages/index.vue'),
          meta: { titleKey: 'route.tracePackages', icon: 'Box', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 87 } }
        },
        {
          path: 'trace-specifications',
          name: 'TraceSpecifications',
          component: () => import('@/views/trace/specifications/index.vue'),
          meta: { titleKey: 'route.traceSpecifications', icon: 'CollectionTag', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 90 } }
        },
        {
          path: 'trace-codes',
          name: 'TraceCodes',
          component: () => import('@/views/trace/codes/index.vue'),
          meta: { titleKey: 'route.traceCodes', icon: 'Grid', roles: ['SUPER_ADMIN'], menuOrder: { SUPER_ADMIN: 100 } }
        },
        {
          path: 'settings',
          name: 'Settings',
          component: () => import('@/views/settings/index.vue'),
          meta: { titleKey: 'route.settings', icon: 'Setting', hidden: true }
        },
        {
          path: 'profile',
          name: 'Profile',
          component: () => import('@/views/profile/index.vue'),
          meta: { titleKey: 'route.profile', icon: 'Lock', menuOrder: { SUPER_ADMIN: 120, AGENT: 80, STORE_ADMIN: 50 } }
        }
      ]
    }
  ]
})

// Route Guard
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()

  if (!to.meta.public && !userStore.token) {
    next('/login')
    return
  }

  // Check role permissions
  if (to.meta.roles && userStore.userInfo) {
    const roles = to.meta.roles as string[]
    const hasPermission = roles.some(role => {
      if (role === 'SUPER_ADMIN') return userStore.isSuperAdmin
      if (role === 'AGENT') return userStore.isAgent
      if (role === 'STORE_ADMIN') return userStore.isStoreAdmin
      return false
    })

    if (!hasPermission) {
      next('/dashboard')
      return
    }
  }

  next()
})

export default router
